import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getLocationsListSelector = createSelector(
  (state) => state[NAME],
  (loc) => loc.list
)

export const getCountyHashSelector = createSelector(
  (state) => state[NAME],
  (locations) => {
    const hash = {}
    locations.list.forEach((loc) => {
      hash[loc.County] = loc
    })
    return hash
  }
)
